/**
 * Simple logger that silences output in production builds.
 * Useful when we want verbose logs during development without polluting console in prod.
 */
const isProductionBuild = process.env.NODE_ENV === 'production';

export const devLog = (...args: Parameters<typeof console.log>): void => {
  if (!isProductionBuild) {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};

export default devLog;
